import * as React from 'react';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import UserCreatePopup from '~/apps/shared/containers/users/UserCreatePopup';


export default function() {
  return (
    <CurrentOrgInjector
      component={UserCreatePopup}
      onReturn={() => navigate('sender.settings.team')}
    />
  );
};
